module.exports = __webpack_public_path__ + "static/media/cloudy.e9ee5d2d.svg";